// Module
var code = "<div style=\"padding-top:200px;\"><md-content><h2>{{ $ctrl.title }}</h2><p>{{ $ctrl.content }}</p></md-content><iframe src=\"http://dev-arescontent.emersonecologics.com/2016/11/11/hello-world/\" style=\"width: 100%; height: 800px; border: none\"></iframe></div>";
// Exports
module.exports = code;